import { render, staticRenderFns } from "./BreadcrumbView.vue?vue&type=template&id=c665d8da&"
import script from "./BreadcrumbView.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbView.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbView.vue?vue&type=style&index=0&id=c665d8da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports